import { h } from "preact";
import { useState } from "preact/hooks";

export default function QuantityInput({
  quantity,
  setQuantity,
  className = "",
  tabindex,
  productTitle = "product",
}) {
  const handleButtonClick = (e) => {
    setQuantity(
      e.target.name === "plus" ? quantity + 1 : Math.max(quantity - 1, 1),
    );
  };

  const handleInputChange = (e) => {
    const newValue = parseInt(e.target.value);

    isFinite(newValue) ? setQuantity(Math.max(newValue, 1)) : 1;
  };

  return (
    <div class={`${className} bundle-config__quantity`}>
      <button
        class="bundle-config__quantity-button bundle-config__quantity-button--decrease"
        name="minus"
        type="button"
        onClick={handleButtonClick}
        disabled={quantity < 2}
        tabindex={tabindex}
      >
        <span class="visually-hidden">{`Decrease quantity for ${productTitle}`}</span>
        -
      </button>
      <label class="bundle-config__quantity-input-label">
        <span class="visually-hidden">{`Quantity for ${productTitle}`}</span>
        <input
          class="body-1-bold bundle-config__quantity-input"
          type="number"
          name="quantity"
          min="1"
          value={quantity}
          onChange={handleInputChange}
          tabindex={tabindex}
        />
      </label>
      <button
        class="bundle-config__quantity-button bundle-config__quantity-button--increase"
        name="plus"
        type="button"
        onClick={handleButtonClick}
        tabindex={tabindex}
      >
        <span class="visually-hidden">{`Increase quantity for ${productTitle}`}</span>
        +
      </button>
    </div>
  );
}
